import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  text-align: center;
  display: flex;
  /* width: 100%; */
  align-items: center;
  justify-content: center;

  /*
  @media (max-width: 860px) {
    transform: scale(0.8);
  }

  @media (max-width: 580px) {
    transform: scale(0.6);
    margin: -40px 0 -70px 0;
  }

  @media (max-width: 420px) {
    transform: scale(0.47);
    margin: -60px 0 -100px 0;
  }
  */

  @media (max-width: 680px) {
    margin: 0 80px;
  }
`

const Canvas = styled.div`
  position: relative;
`

const Img = styled.img`
  position: relative;
  z-index: 2;
  transition: all 0.35s ease;
  will-change: filter;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1));
  max-width: 100%;
  height: auto;

  ${props =>
    props.expanded &&
    css`
      transform: translateX(-64px);
      /* filter: drop-shadow(5px 0 5px rgba(0, 0, 0, 0.2)); */
      /* filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.1)); */

      @media (max-width: 400px) {
        transform: translateX(-32px);
      }
    `}
`

const FlyoutImg = styled.img`
  display: block;
  position: relative;
  z-index: 1;
  transition: all 0.35s ease;
  width: 250px;
  max-width: 70%;
  height: auto;
  position: absolute;
  bottom: 0;
  right: 0;

  ${props =>
    props.expanded &&
    css`
      transform: translateX(64px);

      @media (max-width: 400px) {
        transform: translateX(32px);
      }
    `}
  ${props =>
    props.cardFlyoutNumber === 2 &&
    css`
      width: 300px;
      max-width: 72%;
    `}
  ${props =>
    props.second &&
    css`
      transition-delay: 0.15s;
    `}
  ${props =>
    props.expanded &&
    props.second &&
    css`
      transform: translateX(5px);

      @media (max-width: 400px) {
        transform: translateX(3px);
      }
    `}
`

const CardFlyout = ({
  expanded = false,
  card,
  transparent = false,
  cardFlyoutNumber,
}) => (
  <Wrapper transparent={transparent}>
    <Canvas>
      <Img
        src={card.src}
        srcSet={card.srcSet}
        width={card.width}
        height={card.height}
        expanded={expanded}
      />
      <FlyoutImg
        src={card.src}
        width="250"
        expanded={expanded}
        cardFlyoutNumber={cardFlyoutNumber}
      />
      {cardFlyoutNumber === 2 && (
        <FlyoutImg
          src={card.src}
          width="250"
          expanded={expanded}
          cardFlyoutNumber={cardFlyoutNumber}
          second
        />
      )}
    </Canvas>
  </Wrapper>
)

CardFlyout.propTypes = {
  // expanded: PropTypes.boolean,
  card: PropTypes.object.isRequired,
  transparent: PropTypes.bool,
}

export default CardFlyout
